import { render, staticRenderFns } from "./DebtRelated.vue?vue&type=template&id=4a522199&"
import script from "./DebtRelated.vue?vue&type=script&lang=js&"
export * from "./DebtRelated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports